import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-vh-100 d-flex flex-column" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, {
      onStrat: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('strat'))),
      onTvconnect: _ctx.tvconnect
    }, null, 8, ["onTvconnect"])
  ]))
}